<template>
   <v-container>
     <div itemscope itemtype="http://schema.org/Product">
     <v-layout row wrap>
       <v-flex xs12>
         <v-card>
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             height="450px"
             alt="surfandscan"
             :src="require('../assets/surfandscan_titel.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox>
                   <span class="edoheadlinesurf">surf<span style="color:#97c2e0">and</span>scan</span>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
     </v-layout>

     <div>
       <v-breadcrumbs divider=">" class="edobread">
         <v-breadcrumbs-item
           v-for="item in items"
           :key="item.text"
           :disabled="item.disabled"
         >
           <a :href='item.route'>{{ item.text }}</a>
         </v-breadcrumbs-item>
       </v-breadcrumbs>
     </div>

       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm12 md12>
             <v-card class="edomargintop" flat>
               <v-card-title primary class="title edoheadlinetextsurf">
                 <span itemprop="name">
                 surf<span style="color:#97c2e0">and</span>scan
                 </span>
               </v-card-title>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Wie kann man in der heutigen Zeit herausstechen? In der Zeit wo jeder alles kann. Die meisten Kunden schätzen Service und Komfort. Mit surfandscan können Sie Ihre Kunden mehr Komfort bieten. Sie haben eine Plattform in der User Dokumente hochladen können? Dann können Sie mit surfandscan den Nutzern das lästige suchen nach der Scannersoftware oder dem gescannten Dokument ersparen. Mit surfandscan scannen Sie direkt aus dem Browser. Das heißt mit einem Klick starten Sie den Scanner, er beginnt zu scannen. Nachdem der Scanvorgang abgeschlossen ist haben Sie den Scan direkt auf der Plattform wo Sie ihn brauchen. Kein lästiges Suchen mehr nach der Datei. surfandscan spart Zeit und Nerven – damit können Sie punkten.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>
     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/SurfandScan_scannen.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetext">Scannen und Hochladen</v-card-title>
             <v-card-text class="edoLineText">
               Starten Sie Ihren Scanner direkt im Browser. scanandsurf spricht Ihren angeschlossen Scanner und und beginnt mit dem Scanvorgang.
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder" flat>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetext">Scannen</v-card-title>
             <v-card-text class="edoLineText">
               Ihr Scanner fürht den angestoßenen Scanvorgang aus und speichert die Datei direkt im Browser.
             </v-card-text>
           </v-card>
         </v-flex>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/SurfandScan_scanner.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder" flat>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/SurfandScan_hochladen.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetext">Fertig</v-card-title>
             <v-card-text class="edoLineText">
               Die gescannte Datei ist direkt im Browser sichtbar und kann weg geschickt werden.
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
     </div>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm9 md9>
           <v-card class="edomargintop" flat>
             <div itemprop="email" itemscope itemtype="http://schema.org/PostalAddress">
             <div class="text-xs-center edomargintop">
               <v-btn outline color="grey darken-3" @click="mailto" class="linkedo">
                 <a href="mailto:info@edologic.de" itemprop="email">
                 Mehr Informationen per Mail erhalten
                 </a>
               </v-btn>
             </div>
             </div>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
     <v-layout row wrap>
       <v-container>
         <v-card class="edoabstandfooter" flat>
         </v-card>
       </v-container>
     </v-layout>
   </v-container>
</template>

<script>
  export default {
    name: 'SurfandScan',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'SurfandScan – Scannen war noch nie so einfach',
      meta: [
        {
          name: 'description',
          content: 'Surf and Scan – verbindet das Einfache mit dem Nützlichen'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Produkte',
          route: '/produkte',
          disabled: false
        },
        {
          text: 'SurfandScan',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
      mailto () {
        window.location = 'mailto:info@edologic.de'
      }
    },
    mounted () {
      console.log('Crossfind')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SurfandScan.vue